import BackendService from "../../../backend/controller/BackendService";
import CharacterModel from "../../../characters/model/CharacterModel";
import PlayerModel from "../../../player/model/PlayerModel";
import Conversation from "../../model/Conversation";

export default class ConversationState extends createjs.EventDispatcher {
    /**
     * @param {string} chapterId
     * @param {Conversation} conversation 
     * @param {CharacterModel[]} characters 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationState>} successor state.
     */
    async execute(chapterId, conversation, characters, backendService, playerModel) {
        throw `ConversationState.enter must be implemented by subclass`;
    }

    async reset() {

    }

    /**
     * @param {string} message 
     */
    handlePlayerInput(message) {
        console.warn(`ConversationState.handlePlayerInput not implemented by subclass. Ignoring message: '${message}'.`);
    }

    destroy() {
        this.removeAllEventListeners();
    }
}

ConversationState.SAVE_SNAPSHOT = 'ConversationState.SAVE_SNAPSHOT';
